console.log('this should run on every page EXCEPT the spa ')
import '../styles/bulma_overrides.scss'
import Rails from '@rails/ujs'
Rails.start()

// after much confusion
//https://medium.com/@yoanante/assets-webpacker-and-rails-6-why-your-images-and-css-arent-showing-up-heroku-vs-development-de85047148de
// reverted to putting this scss in assets/stylesheets
//import '../src/bulma.scss'
